<template>
  <modal :show="show" header-classes="justify-content-center center" @close="handleClose()">
    <h4 slot="header">
      Edit {{ bibleStudy.name }}
    </h4>

    <BSForm
      ref="childBSFormComponent"
      :bible-study="bibleStudy"
      :participants="participants"
      :disable-start-date="true"
      :disable-participants="true"
      :all-fields="bibleStudy.user_is_leader"
      :edit-leader="bibleStudy.user_is_leader || bibleStudy.user_can_transfer"
      @returnBSData="saveBS($event)"
    />

    <template slot="footer">
      <p-button @click="handleClose()">
        Cancel
      </p-button>
      <p-button class="custom-modal-type" @click="$refs.childBSFormComponent.validateInput()">
        Save
      </p-button>
    </template>
  </modal>
</template>

<script>
import {
    mapState
} from 'vuex';
import modal from '../UIComponents/Modal';
import BSForm from './Form.vue';

export default {
    name: 'EditBSModal',
    components: {
        modal,
        BSForm
    },
    data() {
        return {
            namespace: 'BibleStudies',
        };
    },
    props: {
        show: Boolean,
        participants: Array,
        bibleStudy: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        saveBS(BSData) {
            this.$store.dispatch(`${this.namespace}/updateBibleStudy`, {
                bible_study_data: BSData.bible_study_data,
                bible_study_schedule_data: BSData.bible_study_schedule_data,
            }).then(
                this.handleClose()
            );
        },
        handleClose() {
            this.$refs.childBSFormComponent.handleClose();
            this.$emit('close');
        },
    },
};
</script>
<style>
.modal-body{
    display: flex;
    justify-content: center;
}
.modal-body{
    display: flex;
    flex-direction: column;
    padding: 20px 10px;
}
.col-md-4{
    margin: auto;
}
.select-default.el-select.light-gray .el-input input {
    border-color: #DCDFE6 !important;
    border-width: 1px;
}
.select-default.el-select.light-gray .el-input:hover input:hover,
.select-default.el-select.light-gray .el-input:hover input, .select-default.el-select .el-input:hover .el-input__icon{
    border-color: #66615B !important;
}
.noError {
  border-left: 5px solid white;
}
.validationError {
  border-left: 5px solid red;
  background-color: lightpink;
  font-weight: bold;
}
.validationErrorText {
  color: red;
  font-weight: bold;
  margin: 3px 0 10px 0;
  text-align: center;
}
.btn.custom-modal-type{
  background-color: #409EFF;
}
.btn:hover.custom-modal-type:hover{
  background-color: #66b1ff !important;
}
</style>

<style scoped>
</style>
